// extracted by mini-css-extract-plugin
export var logo = "_5t-2";
export var logoWrapper = "_5t-1";
export var strip = "_5t-0";